/**
 * Sorts the array based on a start and ending index (mainly for drag and drop reordering)
 * @param array to be modified
 * @param start index
 * @param end index
 * @returns sorted array.
 */
export default function reorder(array: any[], start: number, end: number) {
	const result = [...array];
	const [removed] = result.splice(start, 1);
	result.splice(end, 0, removed);
	return result;
}
